const Alchemy = require('../ability_trees/Alchemy.js');
const ArmorUse = require('../ability_trees/ArmorUse.js');
const Conjuration = require('../ability_trees/Conjuration.js');
const StandardAbilityTree = require('../ability_trees/StandardAbilityTree.js');

const ItemGenerator = require('../../game_items/ItemGenerator.js');
const HeavyHelmet = require('../../game_items/equipment/helmet/HeavyHelmet.js');
const HeavyTorsoe = require('../../game_items/equipment/torsoe/HeavyTorsoe.js');
const HeavyBoots = require('../../game_items/equipment/boots/HeavyBoots.js');
const Staff = require('../../game_items/equipment/weapon/Staff.js');

module.exports = {
  handle: 'battle_mage',
  getAbilityTrees: () => ([
    Alchemy,
    ArmorUse,
    Conjuration,
    StandardAbilityTree,
  ]),
  getBaseAttributes: () => ({
    learning: 8,
    perception: 6,
    mana: 10,
    toughness: 7,
    strength: 5,
    willpower: 10,
    dexterity: 4,
  }),
  getDefaultAIConfig: () => (['dps_close', 'support', 'tank', 'interference', 'dps_ranged']),
  getStarterEquipment: () => ({
    helmet: ItemGenerator.getRandomItem(HeavyHelmet, 0, 0.1, true),
    torsoe: ItemGenerator.getRandomItem(HeavyTorsoe, 0, 0.1, true),
    boots: ItemGenerator.getRandomItem(HeavyBoots, 0, 0.1, true),
    weapon: ItemGenerator.getRandomItem(Staff, 0, 0.1, true),
  }),
};
